<template>
  <section>
    <div class="px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide">
      <h2>RSC</h2>
    </div>
    <div class="bg-white p-4 md:p-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
      <TaskWrapperRSC :value="tasks[0]" :name="$t('lang.msg.factoryContract')" :id-factory="idFactory" />
      <TaskWrapperRSC :value="tasks[1]" :name="$t('lang.msg.signedOrder')" />
      <TaskWrapperRSC :value="tasks[2]" :name="$t('lang.msg.internalLaboratory')" />
      <TaskWrapperRSC :value="tasks[3]" :name="$t('lang.msg.clientLaboratory')" />
      <TaskWrapperRSC :value="tasks[4]" :name="$t('lang.msg.picking')" />
      <TaskWrapperRSC :value="tasks[5]" :name="$t('lang.msg.declarationOfSurplus')" />
<!--      TODO ESPERAR A QUE JESÚS PONGA DECLARACIÓN DE ESTRUCTURAS-->
      <TaskWrapperRSC :value="tasks[6]" :name="$t('lang.msg.declarationOfSubstructures')" />
    </div>
  </section>
</template>

<script>
export default {
  name: "RSC",
  props: {
    tasks: {
      type: Array,
      required: true
    },
    idSample: {
      type: Number,
      required: true
    },
    idFactory: {
      type: Number,
      default: 0
    }
  }
};
</script>
